import React from 'react'
import { ContactUs } from '../../sharedComponents/contactUs'

const ContactUsPage = () => {
  return <ContactUs />
}

export default ContactUsPage
